<template>
  <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
    <div class="flex justify-between items-center mb-6">
      <h3 class="font-bold text-gray-800 text-lg">Daily Operations</h3>
      <span class="text-xs text-gray-500">Recent entries from Audit Log</span>
    </div>

    <div class="space-y-6 max-h-[500px] overflow-y-auto pr-2">
      <div v-for="row in rows" :key="row.log.id" class="flex gap-4" data-testid="operations-row">
        <div
          class="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
          :class="row.icon.bg"
        >
          <i :class="['pi', row.icon.icon, row.icon.text]"></i>
        </div>
        <div>
          <h4 class="text-sm font-semibold text-gray-800">{{ row.title }}</h4>
          <p class="text-xs text-gray-500 mt-0.5">
            <span class="font-medium text-gray-700">{{ row.log.user?.name || 'System' }}</span>
            performed this action
          </p>
          <p class="text-[10px] text-gray-400 mt-1">{{ formatTimeAgo(row.log.created_at) }}</p>
        </div>
      </div>

      <div v-if="logs.length === 0" class="text-center text-gray-400 text-sm py-4">
        No recent activities
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatDistanceToNow } from 'date-fns';
import type { DashboardStats } from '@/types/composition-functions';
import { operationsFeedIcon, operationsFeedTitle } from '@/utils/operationsFeed';

// Extract AuditLogs type
type AuditLog = DashboardStats['auditLogs'][number];

const props = defineProps<{
  logs: AuditLog[]
}>();

const rows = computed(() => props.logs.map((log) => {
  const title = operationsFeedTitle(log);
  return { log, title, icon: operationsFeedIcon(title) };
}));

const formatTimeAgo = (dateStr: string) => {
  try {
    return formatDistanceToNow(new Date(dateStr), { addSuffix: true });
  } catch {
    return dateStr;
  }
};
</script>
